export default "__VITE_ASSET__BphuRzpS__"